module.exports = __webpack_public_path__ + "img/29.8534819c.png";